<div class="title">
  <div
    class="status"
    [ngClass]="{selected, invalid, disabled, visited, revisit: (visitCount>1 || editMode)}"
  >
    @if (icon) {
    <un-icon [type]="icon" theme="fill"></un-icon>
    }
  </div>
  <span class="t-medium" [ngClass]="{ 'c-soft': !selected }">{{
    unTitle
  }}</span>
</div>
@if (selected && description) {
<div
  class="desc t-small h-sm"
  [ngClass]="{ invalid: (visitCount > 1 || editMode) && invalid }"
>
  @if (selected && description) {
  <p class="c-soft">{{ description }}</p>
  }
</div>
}
